module.exports = __webpack_public_path__ + "static/media/grabaseat1.c8f8458b.jpg";